import { FC } from 'react'
import { FileText, Download } from 'lucide-react'
import { DocumentGroupItem } from '../../../services/documentService'

interface DocumentRowProps {
  document: DocumentGroupItem
}

export const DocumentRow: FC<DocumentRowProps> = ({ document }) => (
  <div className="flex items-center justify-between gap-4 border border-olr-grey-2 rounded-lg p-4">
    <div className="flex items-center gap-3 min-w-0">
      <div className="shrink-0 w-10 h-10 rounded-lg bg-olr-primary flex items-center justify-center">
        <FileText size={20} className="text-white" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-gray-900 truncate">
          {document.title}
        </p>
        <p className="text-xs text-gray-500">
          {document.category} · {document.fileSize} · {document.date}
        </p>
      </div>
    </div>
    <div className="flex items-center gap-3 shrink-0">
      <span className="text-xs font-semibold text-green-700 bg-green-100 rounded-full px-3 py-1">
        {document.status}
      </span>
      {document.url ? (
        <a
          href={document.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-olr-primary hover:text-olr-primary-hover"
          aria-label={`Descargar ${document.title}`}
        >
          <Download size={18} />
        </a>
      ) : (
        <Download size={18} className="text-gray-300" aria-hidden="true" />
      )}
    </div>
  </div>
)

export default DocumentRow
